import React from 'react';

import { Col, FlexibleDiv, Row } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { Available } from '@assets/icons';

import {
  Content,
  ImageContainer,
  TextContent,
  Title,
  Wrapper,
  Text,
  Image,
} from './OTP/InfoLabelStyle';

export interface TextItems {
  text?: string;
  title?: string;
}
export interface Image {
  url?: string;
  alt?: string;
}

interface InformationProps {
  title?: string;
  contents?: TextItems[];
  image?: Image;
}

const Information = ({
  title = '',
  contents = [],
  image,
}: InformationProps) => {
  return (
    <Wrapper>
      <Content>
        <Title>{title}</Title>
        <Col>
          {contents?.map((item, key) => (
            <FlexibleDiv top={20} key={key}>
              <Row>
                <CustomIcon icon={Available} fontSize={24} />
                <TextContent>
                  <Text>{item.text}</Text>
                </TextContent>
              </Row>
            </FlexibleDiv>
          ))}
        </Col>
      </Content>
      <ImageContainer>
        {image ? (
          <Image
            width={340}
            height={340}
            src={image.url || ''}
            alt={image.alt || 'image'}
          />
        ) : null}
      </ImageContainer>
    </Wrapper>
  );
};

export default Information;
